export default __webpack_public_path__ + "static/media/bild03.55776a7b.webp";